let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function updateAlAyaCartCount(count) {
  if (typeof count !== 'number') return;

  document.querySelectorAll('[data-aya-cart-count], .aya-icon-count').forEach((element) => {
    element.textContent = count;
  });

  document.querySelectorAll('.aya-utility-bag').forEach((link) => {
    link.setAttribute('aria-label', `Bag (${count} items)`);
  });
}

function refreshAlAyaCartCount() {
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
    .then((response) => {
      if (!response.ok) throw new Error('Unable to refresh cart count');
      return response.json();
    })
    .then((cart) => {
      updateAlAyaCartCount(cart.item_count);
    })
    .catch((error) => {
      console.error(error);
    });
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }

  if (eventName === 'cart-update') {
    const count = data && data.cartData && data.cartData.item_count;
    if (typeof count === 'number') {
      updateAlAyaCartCount(count);
    } else {
      refreshAlAyaCartCount();
    }
  }
}
